export var VideoAnalyticsEvent = /*#__PURE__*/function (VideoAnalyticsEvent) {
  VideoAnalyticsEvent["PLAYER_READY"] = "player-ready";
  VideoAnalyticsEvent["ERROR_TIMEOUT"] = "error-timeout";
  VideoAnalyticsEvent["FIRST_PLAY"] = "first-play";
  VideoAnalyticsEvent["PLAY"] = "play";
  VideoAnalyticsEvent["PAUSE"] = "pause";
  VideoAnalyticsEvent["SEEK"] = "seek";
  VideoAnalyticsEvent["PROGRESS"] = "progress";
  VideoAnalyticsEvent["BACK"] = "back";
  VideoAnalyticsEvent["FORWARD"] = "forward";
  VideoAnalyticsEvent["COMPLETE"] = "complete";
  return VideoAnalyticsEvent;
}({});

// Track function

// useVideoAnalytics